import { render, staticRenderFns } from "./inforDrill.vue?vue&type=template&id=ebc748bc&scoped=true&"
import script from "./inforDrill.vue?vue&type=script&lang=js&"
export * from "./inforDrill.vue?vue&type=script&lang=js&"
import style0 from "./inforDrill.vue?vue&type=style&index=0&id=ebc748bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebc748bc",
  null
  
)

export default component.exports